import { computeFrenchTva } from './computeFrenchTva'

// Country-agnostic seam for deriving a VAT number from a business identifier (SIRET/SIREN).
// Only France is supported today; sibling tickets call this with a dynamic country code.
export const computeVatNumber = (
  countryCode: string | undefined | null,
  siret: string | undefined | null,
): string | null => {
  switch (countryCode) {
    case 'FR':
      return computeFrenchTva(siret)
    default:
      return null
  }
}
